import { FREEHOLDER_ROLE, LEASEHOLDER_ROLE } from "../Settings/constants/index";

/**
 * Check if user information is in layout service meaning user is logged in.
 * @param {Object[]} sitecoreContext - sitecore context from layout service
 * @returns {boolean} if true user is logged in
 */
export const userIsLoggedIn = sitecoreContext => {
  return typeof sitecoreContext !== "undefined" && typeof sitecoreContext.user !== "undefined" && typeof sitecoreContext.user.name !== "undefined" && sitecoreContext.user.name.length > 0;
};

/**
 * Check if user information is in layout service meaning user is logged in.
 * @param {string} role - The role name the user is expected to have.
 * @param {Object[]} sitecoreContext - sitecore context from layout service with user profile
 * @returns {boolean} if true user has role
 */
export const userHasRole = (role, sitecoreContext) => {
  if (typeof sitecoreContext === "undefined" || typeof sitecoreContext.userProfile === "undefined" || typeof sitecoreContext.userProfile.roles === "undefined" || sitecoreContext.userProfile.roles.length === 0) {
    return false;
  }
  if (typeof role === "string") {
    return sitecoreContext.userProfile.roles.indexOf(role) !== -1;
  }
  return false;
};

/**
 * Check if user information is in layout service meaning user is logged in.
 * @param {Object[]} sitecoreContext - sitecore context from layout service with user profile
 * @returns {boolean} if true user has roles for home owner
 */
export const userIsHomeOwner = sitecoreContext => {
  return userHasRole(FREEHOLDER_ROLE, sitecoreContext) || userHasRole(LEASEHOLDER_ROLE, sitecoreContext);
};